'use memo';

import { getYear } from 'date-fns-jalali';
import Link from 'next/link';
import type { ReactNode } from 'react';
import { Aparat, Feed, Instagram, Linkedin, Telegram, XIcon, Youtube } from '@zoomit/icons';
import { isMobile } from '@zoomit/web-kit';
import { mobileBanners, zoobinHelperLinks, zoobinProducts, zoomitSupporters } from '../../constants/footer';
type Props = {
  background: ReactNode;
};
const Footer = (props: Props) => {
  if (isMobile) return <></>;
  const {
    background
  } = props;
  return <footer className="bg-background2 border-borderPrimary relative w-full overflow-hidden border-t">
      {background}

      <div className="mx-auto max-w-[1356px] px-4 pt-6 md:relative md:px-12 md:pt-32">
        <div className="flex w-full">
          <div className="flex grow flex-col gap-5">
            <p className="text-body text-grey1 md:hidden">زوبین</p>
            <p className="text-body text-grey1 border-primary1 hidden max-w-14 rounded-full border-2 md:block" />
            {zoobinHelperLinks.map(i => <Link className="text-body text-text md:hover:underline" href={i.href} key={i.href} rel="nofollow">
                {i.name}
              </Link>)}
          </div>
          <div className="flex grow flex-col gap-5 md:hidden">
            <p className="text-body text-grey1">خانواده ما</p>
            {zoobinProducts.map(i => <Link className="text-body text-text" href={i.href} key={i.href} rel="nofollow">
                {i.name}
              </Link>)}
          </div>
          <div className="text-grey1 hidden grow flex-col gap-5 lg:flex">
            <p className="text-body text-grey1">حامیان زوبین</p>

            {zoomitSupporters.map(i => i.href ? <Link className="text-body md:hover:underline" href={i.href} key={i.href} rel="nofollow">
                  {i.name}
                </Link> : <div className="text-body cursor-default" key={i.href}>
                  {i.name}
                </div>)}
          </div>

          <div className="hidden grow md:block">
            <p className="text-body text-grey1">خانواده ما</p>
            <div className="mt-8 flex justify-between">
              {zoobinProducts.map(product => <Link target="_blank" className="transition-transform md:hover:scale-105" rel="nofollow" href={product.href} key={product.name}>
                  {product.icon}
                </Link>)}
            </div>
          </div>
        </div>

        <div className="mt-9 flex items-center md:hidden">
          <div className="relative flex grow flex-col pr-[0.8rem]">
            <Link className="text-body" href="https://parspack.com/" rel="nofollow">
              پارس پک
            </Link>
            <p className="text-subhead text-grey1 mt-3">میزبان سرور‌های زومیت</p>
          </div>
          <div className="relative flex grow flex-col pr-[0.8rem]">
            <p className="text-body">TheForge</p>
            <p className="text-subhead text-grey1 mt-3">هسته قدرتمند زومیت</p>
          </div>
        </div>

        <div className="mb-6 flex w-full flex-col sm:mt-16 md:flex-row-reverse md:items-end md:justify-between">
          <div>
            {/* Mobile Banners */}
            <div className="flex justify-center gap-[10px] py-7 sm:hidden">
              {mobileBanners.map(({
              href,
              icon,
              name
            }) => <Link className="border-grey6 flex grow-0 items-center justify-center gap-1 rounded-full border px-3 py-2" href={href} rel="nofollow" key={name}>
                  {icon}
                  <p className="text-callout-bold text-grey1">{name}</p>
                </Link>)}
            </div>

            {/* Social Media Icons */}
            <div className="flex justify-around md:justify-start md:gap-5">
              <Link href={'https://www.zoomit.ir/feed/'} rel="nofollow">
                <Feed size="lg" />
              </Link>
              <Link href={'https://www.linkedin.com/company/myzoobin'} rel="nofollow">
                <Linkedin size="lg" />
              </Link>
              <Link className="hidden md:block" href={'https://www.instagram.com/myzoobin/'} rel="nofollow">
                <Instagram size="lg" />
              </Link>
              <Link href={'https://www.aparat.com/zoomit'} rel="nofollow">
                <Aparat size="lg" />
              </Link>
              <Link className="hidden md:block" href={'https://www.youtube.com/c/ZoomitTV'} rel="nofollow">
                <Youtube size="lg" />
              </Link>
              <Link href={'https://t.me/myzoobin/'} rel="nofollow">
                <Telegram size="lg" />
              </Link>
              <Link className="hidden md:block" href={'https://twitter.com/thezoomit/'} rel="nofollow">
                <XIcon size="lg" />
              </Link>
            </div>
          </div>

          {/* Footer Bottom Text */}
          <div className="text-callout fa text-grey1 mt-3 mr-1 leading-8 font-[200] md:mt-0">
            © {getYear(new Date())} کپی بخش یا کل هر کدام از مطالب زوبین تنها با کسب مجوز مکتوب امکان پذیر
            است.
          </div>
        </div>
      </div>

      <div className="bg-black3 absolute bottom-0 left-0 h-4 w-full"></div>
    </footer>;
};
export default Footer;